import { filterStyles } from "@insite/content-library/Widgets/InvoiceHistory/InvoiceHistoryFilter";
import { orderHistoryTableStyles } from "@insite/content-library/Widgets/OrderHistory/OrderHistoryTable";
import { css } from "styled-components";

orderHistoryTableStyles.reorderButton = {
    color: "primary",
    sizeVariant: "medium",
};

filterStyles.appliedFilterTag = {
    color: "primary",
};
